import { render, staticRenderFns } from "./ZjdJiuzhengPl.vue?vue&type=template&id=7c90fa6c&scoped=true"
import script from "./ZjdJiuzhengPl.vue?vue&type=script&lang=js"
export * from "./ZjdJiuzhengPl.vue?vue&type=script&lang=js"
import style0 from "./ZjdJiuzhengPl.vue?vue&type=style&index=0&id=7c90fa6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90fa6c",
  null
  
)

export default component.exports